import { DateRange } from 'react-day-picker';

export const coachKeys = {
  all: ['coaches'] as const,
  lists: () => [...coachKeys.all, 'list'] as const,
  detail: (email: string) => [...coachKeys.all, 'detail', email] as const,
  sessions: (coachIds: string[], dateRange?: DateRange) =>
    [...coachKeys.all, 'sessions', { coachIds, dateRange }] as const,
};
